/* Sans Armure — colours section: front and back of the shirt together, on a disc of the colour */
(function () {
  'use strict';
  var COLS = 6, ROWS = 3;
  function init() {
    document.querySelectorAll('[data-colors]').forEach(function (sec) {
      if (sec.dataset.duo) return;
      var stage = sec.querySelector('[data-colors-stage]'), chips = [].slice.call(sec.querySelectorAll('.sa-chip')), img = sec.querySelector('.sa-colors__img');
      if (!stage || !chips.length || !img) return;
      var src = window.SA_FRONTS || (img.getAttribute('src') || '').replace(/sa-memory-\d+\.webp[^/]*$/, 'sa-fronts.webp');
      if (!/sa-fronts\.webp|^data:/.test(src)) return;
      sec.dataset.duo = '1';
      var probe = new Image();
      probe.onload = function () {
        sec.classList.add('is-duo');
        var pop = document.createElement('span'); pop.className = 'sa-colors__pop'; pop.setAttribute('aria-hidden', 'true');
        var b1 = document.createElement('span'), b2 = document.createElement('span'); b1.className = 'sa-colors__burst'; b2.className = 'sa-colors__burst b2';
        var front = document.createElement('div'); front.className = 'sa-colors__front'; front.setAttribute('role', 'img');
        front.style.backgroundImage = 'url("' + src + '")'; front.style.backgroundSize = (COLS * 100) + '% ' + (ROWS * 100) + '%';
        stage.insertBefore(front, stage.firstChild); stage.insertBefore(b2, stage.firstChild); stage.insertBefore(b1, stage.firstChild); stage.insertBefore(pop, stage.firstChild);
        var btn = document.createElement('button'); btn.type = 'button'; btn.className = 'sa-colors__swap sa-mono';
        btn.innerHTML = '<b data-v="back" class="is-on">Back</b><i aria-hidden="true"></i><b data-v="front">Front</b>'; btn.setAttribute('aria-label', 'Swap front and back');
        stage.appendChild(btn);
        var cur = -1, t = 0;
        function show(quiet) {
          var on = sec.querySelector('.sa-chip.is-on'), i = Math.max(0, chips.indexOf(on)); if (i === cur) return; cur = i;
          var pos = (COLS > 1 ? (i % COLS) / (COLS - 1) * 100 : 0) + '% ' + (ROWS > 1 ? Math.floor(i / COLS) / (ROWS - 1) * 100 : 0) + '%';
          front.setAttribute('aria-label', 'Front of the long sleeve in ' + (on ? on.dataset.name : ''));
          if (quiet) { front.style.backgroundPosition = pos; return; }
          front.classList.add('is-swap'); clearTimeout(t);
          t = setTimeout(function () { front.style.backgroundPosition = pos; front.classList.remove('is-swap'); }, 220);
          [b1, b2].forEach(function (b) { b.classList.remove('is-go'); void b.offsetWidth; b.classList.add('is-go'); });
        }
        function flip() {
          var f = stage.classList.toggle('is-flipped');
          btn.querySelectorAll('b').forEach(function (b) { b.classList.toggle('is-on', (b.dataset.v === 'front') === f); });
        }
        stage.addEventListener('click', flip);
        sec.addEventListener('click', function (e) { if (e.target.closest && e.target.closest('.sa-chip')) setTimeout(show, 0); });
        sec.addEventListener('keydown', function (e) { if (e.target.closest && e.target.closest('.sa-chip')) setTimeout(show, 0); });
        if ('MutationObserver' in window) new MutationObserver(function () { show(); }).observe(sec.querySelector('.sa-colors__wave') || sec, { subtree: true, attributes: true, attributeFilter: ['class'] });
        show(true);
      };
      probe.src = src;
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
